import React from "react";
import VideoDisplayCard from "../displayCard";
import SearchByInput from "../../../../../common/searchByInput";

const VideosDisplayCards = React.memo(
  ({
    helpVideos,
    onVideoSelect,
    selectedVideoLink,
    onInputSearchHelpVideo,
    isLoading
  }) => {
    return (
      <>
        <div className="help-video-boxes">
          <div className="input-search-videos">
            <SearchByInput onInputSearch={onInputSearchHelpVideo} />
          </div>
          {helpVideos?.length > 0 ? (
            helpVideos.map((video, index) => (
              <VideoDisplayCard
                key={index}
                helpVideo={video}
                onVideoSelect={onVideoSelect}
                isSelected={selectedVideoLink === video.url}
              />
            ))
          ) : !isLoading ? (
            <div className="w-layout-grid light-grey skill-center-grid">
              <div>No Video(s) Available</div>
            </div>
          ) : (
            <div>

            </div>
          )}
        </div>
      </>
    );
  }
);

export default VideosDisplayCards;
